import { ConfigType } from "./type";

export const devConf: ConfigType = {
  API_HOST: "http://localhost:8080",
  AUTH0_DOMAIN: "dev-r1bm4rm7n4fvl1xf.jp.auth0.com",
  AUTH0_CLIENT_ID: "zXDh5FmOKFeDlCwq8jxk8jsAwss9pKQ0",
};
